export const GET_GIFT_BY_HASH_ID_REQUEST = 'GET_GIFT_BY_HASH_ID_REQUEST';
export const GET_GIFT_BY_HASH_ID_SUCCESS = 'GET_GIFT_BY_HASH_ID_SUCCESS';
export const GET_GIFT_BY_HASH_ID_ERROR = 'GET_GIFT_BY_HASH_ID_ERROR';
export const RESET_GIFT = 'RESET_GIFT';
